import React, { useState, useMemo, useContext, useEffect } from 'react';
import { useTable } from 'react-table';
import moment from 'moment';
import { Text, Badge, Button, Checkbox } from '@mantine/core';
import { AppLoader } from '../../../../components/common/loader';
import { Styles } from '../../../../components/tables/skutable/production-site/styles';
import ProductionLog from '../../productDevelopment/productionSiteLogModal';
import { ActionModal } from '../../productDevelopment/actionModal';

export const Status99Table = ({ materialData, save, disable }) => {
  const [filterLoading, setFilterLoading] = useState(false);
  const [imp_id, setImp_id] = useState(0);
  const data = materialData;
  const [logModal, setLogModal] = useState({ open: false, id: '' });
  const [checked, setChecked] = useState(false);
  const [actionModal, setActionModal] = useState({ open: false, id: '' });
  const [otherStatus, setotherStatus] = useState({});

  function getLogs(imp_id) {
    setLogModal({ open: true, id: imp_id });
    setImp_id(imp_id);
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Plant',
        accessor: 'selected_plant',
        Cell: ({ row }) => {
          return <Text>{row.original.int_rfs_ps_sku_reference.selected_plant}</Text>;
        },
      },
      {
        Header: 'Standard Price',
        accessor: 'standard_price',
        Cell: ({ row }) => {
          return (
            <Text>
              {row.original.rfs_004_plant_data[0]?.standard_price
                ? row.original.rfs_004_plant_data[0]?.standard_price
                : 'Not Found'}
            </Text>
          );
        },
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ row }) => {
          return (
            <Badge
              color={
                row.original.status === 'In Progress'
                  ? 'yellow'
                  : row.original.status === 'Closed'
                  ? 'green'
                  : 'gray'
              }
              size='lg'
            >
              {row.original.status}
            </Badge>
          );
        },
      },
      {
        Header: 'Action',
        accessor: 'action',
        Cell: ({ row }) => {
          return row.original.status === 'In Progress' || row.original.status === 'Not Started' ? (
            <Checkbox
              checked={checked}
              disabled={row.original.status != 'In Progress' || disable}
              onChange={(event) => {
                setChecked(event.target.checked);
                setotherStatus(row.original?.status_ids);
                setActionModal({ open: true, id: row.original.id });
              }}
              label='Confirm and Close'
            />
          ) : row.original.manually_closed && row.original.status === 'Closed' ? (
            <Text>Manual Closure</Text>
          ) : (
            <Text>Automatic Closure</Text>
          );
        },
      },
      {
        Header: 'Log',
        accessor: 'log',
        Cell: ({ row }) => {
          return (
            <Button 
            onClick={() => getLogs(row.original.id)} 
            style={{background:'black',color:'white'}}>
              View Logs
            </Button>
          );
        },
      },
      {
        Header: 'Step Deadline',
        accessor: 'step_deadline',
        Cell: ({ row }) => {
          return <Text>{moment(row.original.sla_date).format('YYYY-MM-DD')}</Text>;
        },
      },
      {
        Header: 'Step Finished',
        accessor: 'step_finished',
        Cell: ({ row }) => {
          return (
            <Text>
              {row.original.finished_date
                ? moment(row.original.finished_date).format('YYYY-MM-DD')
                : row.original.status}
            </Text>
          );
        },
      },
    ],
    [],
  );

  const tableInstance = useTable({
    columns,
    data,
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

  return (
    <Styles>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: 'fitContent' }} {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} id='header-row'>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                  })}
                </tr>
              );
            })}
            {filterLoading && (
              <tr>
                <td colSpan={13}>
                  <div className='loader-container'>
                    <AppLoader size={'md'} />
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {actionModal && (
        <ActionModal
          actionModal={actionModal}
          setActionModal={setActionModal}
          save={save}
          status_id={otherStatus}
        />
      )}

      {logModal && (
        <ProductionLog logModal={logModal} setLogModal={setLogModal} id={imp_id} type='Status 99' />
      )}
    </Styles>
  );
};
